import {put, takeLatest, delay} from 'redux-saga/effects';
import {searchQueryChanged, setSearchQuery} from './searchAndFilterSlice';

function* handleSearchQuery(action) {
    yield delay(10);
    const searchQuery = action.payload;
    yield put(setSearchQuery(searchQuery));
}

export function* watchSearchFilterSaga() {
    yield takeLatest(searchQueryChanged, handleSearchQuery);
}
